/*
  Safety net for Prestige's scroll-reveal on product cards.

  theme.css hides [reveal-on-scroll="true"] with opacity:0 inside
  @media (prefers-reduced-motion: no-preference), and theme.js is what fades those cards back in.
  If theme.js never runs, or its IntersectionObserver never fires, or Motion One throws, the
  affected cards stay invisible forever. The @media (scripting: none) rule in theme.css only
  covers browsers with scripting disabled entirely - not slow, blocked or erroring JS.

  This only rescues cards that are BOTH near the viewport AND provably stuck:
    - computed opacity is ~0, and
    - the element has no running or finished animation attached.
  A card in Motion One's 0.4s start delay reports playState "running", so a healthy reveal is
  never interrupted. Cards further down the page keep their animation and are never touched.
  Revealing is done by removing the attribute, so the CSS rule simply stops matching: opacity
  only, no transform, no layout change, and theme.js can no longer select the card either
  (no duplicate animation).
*/
(function () {
  'use strict';

  var TIMEOUT = 2500; // ms after load before the first sweep
  var MARGIN = 200;   // px beyond the fold still treated as "near"

  function stillStuck(el) {
    if (parseFloat(getComputedStyle(el).opacity) > 0.01) return false;
    var anims = el.getAnimations ? el.getAnimations() : [];
    for (var i = 0; i < anims.length; i++) {
      var state = anims[i].playState;
      if (state === 'running' || state === 'finished') return false;
    }
    return true;
  }

  function nearViewport(el) {
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    return r.top < window.innerHeight + MARGIN && r.bottom > -MARGIN;
  }

  function sweep() {
    var cards = document.querySelectorAll('[reveal-on-scroll="true"]');
    for (var i = 0; i < cards.length; i++) {
      if (nearViewport(cards[i]) && stillStuck(cards[i])) {
        cards[i].removeAttribute('reveal-on-scroll');
      }
    }
  }

  function schedule() {
    setTimeout(sweep, TIMEOUT);
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });

  var scrollTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(sweep, 600);
  }, { passive: true });
})();
